var styles = {"root":"Radio-module_root__1ra24","fakeRadio":"Radio-module_fakeRadio__3lUdZ","input":"Radio-module_input__3e1nF"};

export { styles as default };
//# sourceMappingURL=Radio.module.css.js.map
